import moment from "moment";

const toYMD = (d) => (d ? moment(d).format("YYYY-MM-DD") : null);

export const edocumentsFiltersToParams = (filters = {}) => ({
  type: filters.type,
  invoice_type: filters.invoice_type,
  offset: filters.offset ?? 0,
  limit: filters.limit ?? 20,

  from_date: toYMD(filters.from_date ?? filters.dateStart),
  to_date: toYMD(filters.to_date ?? filters.dateEnd),
});
